export default function Hero() {
  const today = new Date().getDay(); // 0 = Sunday
  const isOpen = today >= 1 && today <= 6;

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      aria-label="Passport and visa photo studio in Scarborough"
    >
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/db3be57575868c1359c22712bfedf152.jpg"
          alt="Professional passport photo studio"
          className="w-full h-full object-cover object-top"
          fetchPriority="high"
          decoding="async"
          width={1920}
          height={1080}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full py-20">
        <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
          Passport &amp; Visa Photos in Scarborough and Markham – Ready in 30 Minutes
        </h2>
        
        <p className="text-lg sm:text-xl text-white/95 mb-10 max-w-4xl mx-auto leading-relaxed" itemProp="description">
          Professional passport photos and visa photos for Canada, USA, India, China, Sri Lanka, UK, Schengen, Australia and more. Correct sizes. Clean background. Fast service.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6">
          <a
            href="tel:+16476289141"
            className="bg-blue-900 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-blue-800 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            <i className="ri-phone-line mr-2"></i>
            Call Now
          </a>
          <a
            href="https://www.google.com/maps/search/?api=1&query=3351+Markham+Rd+Unit+110+Scarborough+ON+M1X+0A6"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white text-gray-900 px-8 py-4 rounded-lg text-base font-semibold hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer w-full sm:w-auto"
          >
            <i className="ri-map-pin-line mr-2"></i>
            Get Directions
          </a>
        </div>

        {/* Address Line */}
        <div className="mb-10" itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
          <p className="text-white text-base font-medium">
            <i className="ri-map-pin-2-fill mr-2"></i>
            <span itemProp="streetAddress">3351 Markham Rd Unit 110</span>, <span itemProp="addressLocality">Scarborough</span>, <span itemProp="addressRegion">ON</span> <span itemProp="postalCode">M1X 0A6</span>
          </p>
        </div>

        {/* Hours Badge */}
        <div className="flex justify-center mb-10">
          <time 
            className="inline-flex items-center gap-3 bg-white/15 backdrop-blur-md border border-white/30 rounded-full px-6 py-3 shadow-lg"
            dateTime={isOpen ? "Mo-Sa 11:00-18:00" : ""}
          >
            <div className={`w-8 h-8 flex items-center justify-center ${isOpen ? 'bg-green-400' : 'bg-red-400'} rounded-full flex-shrink-0`}>
              <i className="ri-time-line text-white text-base"></i>
            </div>
            <div className="flex items-center gap-2 text-white">
              <span className={`text-sm font-semibold tracking-wide uppercase ${isOpen ? 'text-green-300' : 'text-red-300'}`}>
                {isOpen ? 'Open Today' : 'Closed Today'}
              </span>
              <span className="text-white/50">|</span>
              <span className="text-sm font-bold">Mon – Sat: 11:00 AM – 6:00 PM</span>
              <span className="text-white/50 hidden sm:inline">|</span>
              <span className="text-sm text-white/80 hidden sm:inline">Sunday: Closed</span>
            </div>
          </time>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
          <div className="bg-white/95 backdrop-blur-sm p-6 rounded-lg shadow-lg">
            <div className="w-12 h-12 flex items-center justify-center mb-3 mx-auto">
              <i className="ri-time-line text-3xl text-blue-900"></i>
            </div>
            <p className="text-gray-900 font-semibold text-sm">Ready within 30 minutes</p>
          </div>

          <div className="bg-white/95 backdrop-blur-sm p-6 rounded-lg shadow-lg">
            <div className="w-12 h-12 flex items-center justify-center mb-3 mx-auto">
              <i className="ri-walk-line text-3xl text-blue-900"></i>
            </div>
            <p className="text-gray-900 font-semibold text-sm">Walk-ins welcome</p>
          </div>

          <div className="bg-white/95 backdrop-blur-sm p-6 rounded-lg shadow-lg">
            <div className="w-12 h-12 flex items-center justify-center mb-3 mx-auto">
              <i className="ri-global-line text-3xl text-blue-900"></i>
            </div>
            <p className="text-gray-900 font-semibold text-sm">International sizing expertise</p>
          </div>

          <div className="bg-white/95 backdrop-blur-sm p-6 rounded-lg shadow-lg">
            <div className="w-12 h-12 flex items-center justify-center mb-3 mx-auto">
              <i className="ri-map-pin-2-line text-3xl text-blue-900"></i>
            </div>
            <p className="text-gray-900 font-semibold text-sm">Located on Markham Rd (Scarborough)</p>
          </div>
        </div>
      </div>
    </section>
  );
}